import { useAtom } from "jotai";
import { useHydrateAtoms } from "jotai/utils";
import { seeMoreCoversStateAtom } from "../../store";

export const useSetSeeMoreCoversState = (seeMoreCovers: boolean) => {
  useHydrateAtoms([[seeMoreCoversStateAtom, seeMoreCovers]]);
};

// This is a simple wrapper around Jotai
// to reduce imports in components.
export const useCoverGeniusSeeMoreCoversState = () =>
  useAtom(seeMoreCoversStateAtom);
